import React from 'react';
import { connect } from 'react-redux';

import { HtmlContent } from '@dndbeyond/character-components/es';
import { rulesEngineSelectors, Constants, RuleData, RuleDataUtils } from '@dndbeyond/character-rules-engine/es';

import { SidebarHeader } from '../../../components/Sidebar';
import { SharedAppState } from '../../../stores/typings';

interface Props {
    ruleData: RuleData;
}
class ProficiencyBonusPane extends React.PureComponent<Props> {
    render() {
        const { ruleData } = this.props;

        let rule = RuleDataUtils.getRule(Constants.RuleKeyEnum.PROFICIENCY_BONUS, ruleData);
        let description: string = '';
        if (rule && rule.description) {
            description = rule.description;
        }

        return (
            <div className="ct-proficiency-bonus-pane">
                <SidebarHeader>Proficiency Bonus</SidebarHeader>
                <HtmlContent className="ct-proficiency-bonus-pane__description" html={description} />
            </div>
        );
    }
}

function mapStateToProps(state: SharedAppState) {
    return {
        ruleData: rulesEngineSelectors.getRuleData(state),
    };
}

export default connect(mapStateToProps)(ProficiencyBonusPane);
